import styled from "styled-components";

const EmileInfo = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (min-width: 1025px) and (max-width: 1440px) {
    width: 55%;
  }
`;

export { EmileInfo };
